/* CY FEATURED COLLECTION (2026-10-07; the rail 2026-10-17) — the "Shop" carousel's navigation; see assets/cy-featured-collection.css.
   The track is a native scroll-snap row (swipe / trackpad work without this script). This adds: the RAIL (a slider that reads
   the row's position: a well, a knob as wide as the part of the row on screen, sliding as the row scrolls; drag the knob, tap
   the well, arrow keys on it; it lands on a page), the page counter "01 / 03", two arrows that move exactly one page and
   switch off at the ends, arrow keys on the focused track, and mouse drag on the track (a drag never opens a card).
   Owner 2026-10-17: "design something meaningful and creative for these, also active for mobile" (the index bars before). */
(function () {
  'use strict';
  var still = window.matchMedia('(prefers-reduced-motion: reduce)');
  var pad = function (n) { return String(n).padStart(2, '0'); };
  function init(w) {
    if (w.dataset.cyFcOn) return; w.dataset.cyFcOn = '1';
    var tr = w.querySelector('[data-cy-fc-track]'), nav = w.querySelector('[data-cy-fc-nav]');
    var prev = w.querySelector('[data-cy-fc-prev]'), next = w.querySelector('[data-cy-fc-next]');
    var rail = w.querySelector('[data-cy-fc-rail]'), knob = w.querySelector('[data-cy-fc-knob]'), cur = w.querySelector('[data-cy-fc-cur]'), total = w.querySelector('[data-cy-fc-total]');
    if (!tr) return;
    var cards = function () { return Array.prototype.filter.call(tr.children, function (e) { return e.classList.contains('pc'); }); };
    var max = function () { return Math.max(0, tr.scrollWidth - tr.clientWidth); };
    var step = function () { var c = cards(); return c.length > 1 ? c[1].offsetLeft - c[0].offsetLeft : tr.clientWidth; };
    var perView = function () {
      var cs = getComputedStyle(tr), inner = tr.clientWidth - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight);
      return Math.max(1, Math.floor((inner + parseFloat(cs.columnGap || 0)) / step() + .02));
    };
    var pages = function () { var n = cards().length, pv = perView(); return Math.max(1, Math.ceil((n - pv) / pv) + 1); };
    var left = function (p) {                                  /* the scroll position that puts page p's first card at the gutter */
      var c = cards(); if (!c.length) return 0; var k = Math.min(c.length - 1, p * perView());
      return Math.min(max(), c[k].offsetLeft - c[0].offsetLeft);
    };
    var current = function () {
      if (tr.scrollLeft >= max() - 2) return pages() - 1;
      return Math.max(0, Math.min(pages() - 1, Math.round(tr.scrollLeft / (perView() * step()))));
    };
    var go = function (p) { p = Math.max(0, Math.min(pages() - 1, p)); tr.scrollTo({ left: left(p), behavior: still.matches ? 'auto' : 'smooth' }); };
    var land = function () { var st = step(), k = Math.round(tr.scrollLeft / st); tr.scrollTo({ left: Math.min(max(), k * st), behavior: still.matches ? 'auto' : 'smooth' }); };
    /* the rail: the knob's width is the share of the row on screen, its place the scroll position */
    var knobW = 0, railW = 0;
    var geometry = function () {
      if (!rail || !knob) return;
      railW = rail.clientWidth; var min = parseFloat(getComputedStyle(knob).minWidth) || 44;
      knobW = Math.max(min, Math.min(railW, Math.round(railW * tr.clientWidth / Math.max(1, tr.scrollWidth))));
      knob.style.width = knobW + 'px';
    };
    /* 2026-10-23 (speed, MEDIA-SPEED-PLAN phase 1): READ everything, then write only what changed. paint used to read the row's sizes,
       write the arrows and labels, then read the sizes again (a forced re-style on every scroll frame and resize). */
    var was = {};
    var set = function (k, v, fn) { if (was[k] !== v) { was[k] = v; fn(v); } };
    var paint = function () {
      var m = max(), sl = tr.scrollLeft, n = pages(), c = current(), fits = m <= 2;
      var rw = 0, kw = 0;
      if (rail && knob) { rw = rail.clientWidth; var min = parseFloat(getComputedStyle(knob).minWidth) || 44; kw = Math.max(min, Math.min(rw, Math.round(rw * tr.clientWidth / Math.max(1, tr.scrollWidth)))); railW = rw; knobW = kw; }
      /* writes */
      if (nav) set('fits', fits, function (v) { nav.hidden = v; });          /* everything fits: no navigation */
      set('cls', fits, function (v) { w.classList.toggle('is-fits', v); });   /* ... and the row is centred, no blank space at one end */
      if (cur) set('cur', pad(c + 1), function (v) { cur.textContent = v; });
      if (total) set('total', pad(n), function (v) { total.textContent = v; });
      if (rail) set('aria', n + '/' + (c + 1), function () { rail.setAttribute('aria-valuemax', String(n)); rail.setAttribute('aria-valuenow', String(c + 1)); rail.setAttribute('aria-valuetext', 'Page ' + (c + 1) + ' of ' + n); });
      if (rail && knob) { set('kw', kw, function (v) { knob.style.width = v + 'px'; }); knob.style.transform = 'translateX(' + (m ? (sl / m) * (rw - kw) : 0).toFixed(1) + 'px)'; }
      if (prev) set('prev', sl <= 2, function (v) { prev.disabled = v; });
      if (next) set('next', sl >= m - 2, function (v) { next.disabled = v; });
    };
    var raf = 0; var queue = function () { if (!raf) raf = requestAnimationFrame(function () { raf = 0; paint(); }); };
    tr.addEventListener('scroll', queue, { passive: true });
    if ('ResizeObserver' in window) { var ro = new ResizeObserver(queue); ro.observe(tr); if (rail) ro.observe(rail); } else window.addEventListener('resize', queue);
    if (prev) prev.addEventListener('click', function () { go(current() - 1); });
    if (next) next.addEventListener('click', function () { go(current() + 1); });
    tr.addEventListener('keydown', function (e) {
      if (e.target !== tr) return;
      if (e.key === 'ArrowRight') { e.preventDefault(); go(current() + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(current() - 1); }
    });
    /* the rail: drag the knob (mouse, pen, finger), tap the well to jump there, arrow keys when focused; lands on a page */
    if (rail && knob) {
      var drag = null;
      var at = function (clientX) { var r = rail.getBoundingClientRect(); var x = clientX - r.left - knobW / 2; return Math.max(0, Math.min(1, x / Math.max(1, railW - knobW))); };
      rail.addEventListener('pointerdown', function (e) {
        if (e.button !== 0) return; e.preventDefault(); geometry();
        var onKnob = e.target === knob || knob.contains(e.target);
        var r = rail.getBoundingClientRect(), kx = (tr.scrollLeft / Math.max(1, max())) * (railW - knobW);
        drag = { id: e.pointerId, off: onKnob ? (e.clientX - r.left - kx) : knobW / 2 };
        rail.classList.add('is-drag'); try { rail.setPointerCapture(e.pointerId); } catch (x) {}
        if (!onKnob) tr.scrollLeft = at(e.clientX) * max();
      });
      rail.addEventListener('pointermove', function (e) {
        if (!drag || e.pointerId !== drag.id) return;
        var r = rail.getBoundingClientRect(); var x = e.clientX - r.left - drag.off; var ratio = Math.max(0, Math.min(1, x / Math.max(1, railW - knobW)));
        tr.scrollLeft = ratio * max();
      });
      var release = function (e) { if (!drag || (e && e.pointerId !== undefined && e.pointerId !== drag.id)) return; drag = null; rail.classList.remove('is-drag'); land(); };
      rail.addEventListener('pointerup', release); rail.addEventListener('pointercancel', release); rail.addEventListener('lostpointercapture', release);
      rail.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') { e.preventDefault(); go(current() + 1); }
        if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') { e.preventDefault(); go(current() - 1); }
        if (e.key === 'Home') { e.preventDefault(); go(0); }
        if (e.key === 'End') { e.preventDefault(); go(pages() - 1); }
      });
    }
    /* mouse drag on the track (desktop): free scroll while dragging, then land on the nearest card; a drag does not click */
    var down = null, moved = false;
    tr.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0 || e.target.closest('button, input, select, label, .pc__opt')) return;
      down = { x: e.clientX, s: tr.scrollLeft, id: e.pointerId }; moved = false;
    });
    tr.addEventListener('pointermove', function (e) {
      if (!down || e.pointerId !== down.id) return;
      var dx = e.clientX - down.x;
      if (!moved && Math.abs(dx) > 6) { moved = true; tr.classList.add('is-dragging'); try { tr.setPointerCapture(e.pointerId); } catch (x) {} }
      if (moved) tr.scrollLeft = down.s - dx;
    });
    var up = function () {
      if (!down) return; down = null;
      if (!moved) return;
      tr.classList.remove('is-dragging'); land();
    };
    tr.addEventListener('pointerup', up); tr.addEventListener('pointercancel', up); tr.addEventListener('lostpointercapture', up);
    tr.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
    paint();
  }
  function all(root) { Array.prototype.forEach.call((root || document).querySelectorAll('[data-cy-fc]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { all(); }); else all();
  document.addEventListener('shopify:section:load', function (e) { all(e.target); });
  document.addEventListener('cy:fc:load', function (e) { all(e.target); });   /* a track dropped in later (the recommendations row, 2026-10-17) */
})();
